import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { FC, useEffect, useState, useRef } from "react";
import { useStyles } from "../Styles/LockTokenStyles";
import { LockActionProps } from "../../interfaces";
import ticketLogo from "../../assets/images/ticket_bg_logo.png";

const InvestActionCards: FC<any> = ({ usdPerTicketValue, cap, code }) => {
  const style = useStyles();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const updateTimer = useRef({});

  const [, setTicketsOutline] = useState(false);

  const setUpdate = () => {
    setTicketsOutline(true);
    updateTimer.current = setTimeout(() => {
      setTicketsOutline(false);
      updateTimer.current = 0;
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (updateTimer.current) {
        clearTimeout(updateTimer.current as any);
      }
    };
  }, []);

  return (
    <>
      <Grid
        item
        component={Card}
        elevation={0}
        style={{
          marginTop: "20px",
          padding: 0,
        }}
      >
        <CardContent
          style={{
            padding: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: isActive ? "row" : "column",
            gap: isActive ? "1rem" : 0,
          }}
        >
          <Grid container alignItems={"center"}>
            <Box className={style.ticketsBox1}>
              <>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  width={isActive ? "90%" : "100%"}
                >
                  <Typography
                    color="secondary"
                    style={{ fontSize: "14px" }}
                    component="p"
                  >
                    Individual Cap To Invest
                  </Typography>
                  <img src={ticketLogo} alt="tickets" className="ticket-logo" />
                </Box>
                <Typography
                  component="h3"
                  style={{ fontSize: "28px", color: "#ffffff" }}
                  color="primary"
                >
                  <span>$</span>
                  {cap}
                </Typography>{" "}
              </>
            </Box>
          </Grid>
        </CardContent>
      </Grid>
    </>
  );
};

export default InvestActionCards;
